var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house",
    clipPath: "url(#clip0_0_62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.74737 0.302343C9.31579 -0.0984377 8.64912 -0.0984377 8.22105 0.302343L0.361404 7.61484C0.0245615 7.93125 -0.0877192 8.41992 0.0807019 8.84883C0.249123 9.27773 0.659649 9.5625 1.12281 9.5625H1.68421V15.75C1.68421 16.991 2.69123 18 3.92982 18H14.0351C15.2737 18 16.2807 16.991 16.2807 15.75V9.5625H16.8421C17.3053 9.5625 17.7193 9.27773 17.8877 8.84883C18.0561 8.41992 17.9439 7.92773 17.607 7.61484L9.74737 0.302343ZM8.42105 11.25H9.54386C10.4737 11.25 11.2281 12.0059 11.2281 12.9375V16.3125H6.73684V12.9375C6.73684 12.0059 7.49123 11.25 8.42105 11.25Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-home.0219fb7b8f4afbc79664146c7ae91b60.svg";